var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareScreenReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "svg-share-screen-replace-a",
    d: "m2 6 .705.705L5.5 3.915V10h1V3.915L9.29 6.71 10 6 6 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg-share-screen-replace-c",
    d: "M0 0h25v25H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 43,
    x: 1,
    y: 1,
    stroke: "var(--svg-bg-color)",
    strokeWidth: 2,
    strokeOpacity: "var(--svg-bg-opacity)",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 17.5,
    x: 4,
    y: 24,
    fill: "var(--svg-bg-color)",
    fillOpacity: "var(--svg-bg-opacity)",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 17.5,
    x: 4,
    y: 4,
    fill: "var(--svg-bg-color)",
    fillOpacity: "var(--svg-bg-opacity)",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 17.5,
    x: 41,
    y: 23.5,
    fill: "var(--svg-bg-color)",
    fillOpacity: "var(--svg-bg-opacity)",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 17.5,
    x: 41,
    y: 4,
    fill: "currentColor",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.5 7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "svg-share-screen-replace-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-share-screen-replace-a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg-share-screen-replace-b)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-share-screen-replace-c",
    fill: "var(--svg-arrow-color)",
    transform: "translate(-6.5 -6.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenReplace);
export default __webpack_public_path__ + "static/media/share-screen-replace.140b622e3f97bcbfbf2de5c0853d2377.svg";
export { ForwardRef as ReactComponent };